import React, { useEffect, useState, useRef } from 'react';
import { GetDictionary } from '../../utilities/CommonFunctions';
import aboutImg from "../../assets/images/about/2.jpg";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Button } from 'primereact/button';
import { TieredMenu } from 'primereact/tieredmenu';
import { GETApplicationManual_url } from "../../services/end-url";
import CommonService from "../../services/common.service";
import { clickHandler } from 'react-router-dom';
import { useSelector } from "react-redux";
const MultiLevelDropdown = () => {

  const [dic_lng, setdic_lng] = useState({});
  const { user: currentUser } = useSelector((state) => state.auth);
  useEffect(() => {
    async function callfunc() {
      let d = await GetDictionary("2,7");
      setdic_lng(d);
    }
    callfunc()

    async function ApplicationManual() {
      try {
        await CommonService.get(GETApplicationManual_url, currentUser.user_type)
          .then(response => {
            let res = [];
            let res1 = [];
            globalThis.config.Settings.ApiConfiguration.Permissions = response.data.Permissions;
            response.data.ApplicationManual.forEach(element => {
              var resource_label = globalThis.config.Settings.Locale == 'en' ? element.resource_en : element.resource_as;
              var element_url = globalThis.config.Settings.Locale == 'en' ? element.url_en : element.url_as
              if (element.menulev0 != 0 && res[element.menulev0] == undefined) {
                if (element_url != null && element_url != '') {
                  res[element.menulev0] = { label: resource_label, icon: 'pi pi-file', url: 'http://corp-sqldb' + element_url, target: '_blank' }
                } else {
                  res[element.menulev0] = { label: resource_label, icon: 'pi pi-file' }
                }
              } if (element.menulev1 != 0) {
                if (res[element.menulev0].items == undefined) {
                  res[element.menulev0].items = [];
                }
                (res[element.menulev0].items)[element.menulev1] = { label: resource_label, icon: 'pi pi-file' }
                if (element.menulev2 == 0) {
                  if (element_url != null && element_url != '') {
                    (res[element.menulev0].items)[element.menulev1] = { label: resource_label, icon: 'pi pi-file', url: 'http://corp-sqldb' + element_url, target: '_blank' }
                  } else {
                    (res[element.menulev0].items)[element.menulev1] = { label: resource_label, icon: 'pi pi-file' }
                  }

                }
              }
              if (element.menulev2 != 0) {
                if (res[element.menulev0].items[element.menulev1].items == undefined) {
                  res[element.menulev0].items[element.menulev1].items = [];
                }
                (res[element.menulev0].items[element.menulev1].items).push({ label: resource_label, icon: 'pi pi-file' })
              }
              // res["menu" + element.resource_id] = "resource-" + element.resource_id
            });
            setResource(res);
          }).catch(e => {
            console.log(e);
          });
      } catch { }
    };
    ApplicationManual()
  }, [])
  const clickHandler = (e) => {
    console.log(e)
    console.log('jgg')
  }
  const menu = useRef(null);
  const [Resource, setResource] = useState([]);
  const items = [
    {
      label: 'File',
      icon: 'pi pi-file',
      items: [
        {
          label: 'New',
          icon: 'pi pi-plus',
          items: [
            {
              label: 'Document',
              icon: 'pi pi-file'
            },
            {
              label: 'Image',
              icon: 'pi pi-image'
            },
            {
              label: 'Video',
              icon: 'pi pi-video'
            }
          ]
        },
        {
          label: 'Open',
          icon: 'pi pi-folder-open'
        },
        {
          label: 'Print',
          icon: 'pi pi-print'
        }
      ]
    },
    {
      label: 'Edit',
      icon: 'pi pi-file-edit',
      items: [
        {
          label: 'Copy',
          icon: 'pi pi-copy'
        },
        {
          label: 'Delete',
          icon: 'pi pi-times'
        }
      ]
    },
    {
      label: 'Search',
      icon: 'pi pi-search'
    },
    {
      separator: true
    },
    {
      label: 'Share',
      icon: 'pi pi-share-alt',
      items: [
        {
          label: 'Slack',
          icon: 'pi pi-slack'
        },
        {
          label: 'Whatsapp',
          icon: 'pi pi-whatsapp'
        }
      ]
    }
  ];

  return (
    <>
      <div className="card flex justify-content-center">
        <div className='w-25'>
          {
            Resource.length > 0 ?
              <TieredMenu model={Resource} popup="true" ref={menu} breakpoint="767px" />
              : ""
          }


          <Button /*label={dic_lng["manual"]} */ icon="bi bi-file-earmark-richtext" severity="secondary" className='py-1 px-2' outlined onClick={(e) => menu.current.toggle(e)} aria-label="Manual" title="Manual">
            <i className="pi pi-chevron-down px-1"></i>
          </Button>
        </div>
      </div>


    </>
  )
}

export default MultiLevelDropdown